export const TEMPLATE = {
  PARKING: 'YYYY.MM.DD HH:mm',
} as const;
